import React from 'react'

const Btn = ( { label, color, handlePress } ) => {
    return (
        <button onClick={handlePress} type="button" className="mx-1 w-auto text-white px-2 py-1 rounded" style={{ backgroundColor: color }}>
            {label}
        </button>
    )
}

export default Btn
